//` ##### 25-02-05 Komarov
import { Alert, Input } from 'antd';
import React from 'react';
import { markRequired } from '../../../../../helpers/markRequired';

// ##### Komarov 2025-07-14
const LabelTextArea = props => {
  const { TextArea } = Input;

  return (
    <>
      <span>
        {(props.required && markRequired(props.labelText)) || props.labelText}
      </span>
      <TextArea
        rows={1}
        style={{ marginTop: '0.5vh', marginBottom: '0.5vh' }}
        onChange={props.onChange}
        value={props.value}
        // ##### 23-10-02 Komarov: если поле не заполнено, оно обводится красной полоской
        status={props.required && props.alertTrigger && 'error'}
      />
      {/* ##### 23-10-02 Komarov: оповещение пользователя о необходимости заполнить это поле */}
      {props.required && props.alertTrigger && (
        <Alert
          message={props.message}
          type="error"
          showIcon
          closable
          onClose={props.onClose}
        />
      )}
    </>
  );
};

// ##### 25-05-21 Komarov
export default LabelTextArea;
